/**
 * Pixelgipfel Produktvergleich — Client-Side.
 * - localStorage 'pg:compare' hält bis zu 3 Produkt-Handles
 * - Produktkarten (data-pg-compare-toggle) togglen ein Handle in die Liste
 * - Header-Chip zeigt aktuelle Anzahl, klickt zur /pages/vergleich
 * - Custom-Event 'pg:compare-updated' feuert bei jeder Änderung
 */
(function () {
  'use strict';
  var KEY = 'pg:compare';
  var MAX = 3;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  }
  function write(handles) {
    // m120: try/catch — Safari Private Mode / Quota wirft sonst ungefangen
    try { localStorage.setItem(KEY, JSON.stringify(handles.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('pg:compare-updated', { detail: { count: handles.length, list: handles } }));
  }

  function toggle(handle) {
    var list = read();
    var idx = list.indexOf(handle);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX) {
        showToast(window.pgCompareMaxMsg || ('Maximal ' + MAX + ' Produkte vergleichen.'));
        return false;
      }
      list.push(handle);
    }
    write(list);
    return true;
  }

  function showToast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.setAttribute('role', 'status');
    t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);' +
      'background:var(--pg-ink);color:var(--pg-bg);padding:10px 18px;border-radius:999px;' +
      'font-size:13px;font-weight:600;box-shadow:0 6px 20px rgba(0,0,0,.15);z-index:9999;' +
      'opacity:0;transition:opacity .2s;';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 300); }, 2400);
  }

  function syncToggleStates() {
    var list = read();
    document.querySelectorAll('[data-pg-compare-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var on = list.indexOf(handle) >= 0;
      btn.setAttribute('data-pg-in-compare', on ? 'true' : 'false');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // Header-Chip
    document.querySelectorAll('[data-pg-compare-count]').forEach(function (el) {
      el.textContent = String(list.length);
      el.setAttribute('data-empty', list.length === 0 ? 'true' : 'false');
      var chip = el.closest('.pg-mini-chip--cmp');
      if (chip) chip.setAttribute('data-empty', list.length === 0 ? 'true' : 'false');
    });
  }

  function wire() {
    document.querySelectorAll('[data-pg-compare-toggle]').forEach(function (btn) {
      if (btn.dataset.pgCompareWired === '1') return;
      btn.dataset.pgCompareWired = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;
        if (toggle(handle)) syncToggleStates();
      });
    });
  }

  document.addEventListener('pg:compare-updated', syncToggleStates);
  document.addEventListener('pg:cards-updated', function () { wire(); syncToggleStates(); });
  document.addEventListener('shopify:section:load', function () { wire(); syncToggleStates(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); syncToggleStates(); });
  } else {
    wire();
    syncToggleStates();
  }
})();
